import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PencilModalSizeEnum } from 'src/app/standalones/components/modals/modal-template/modal-template.component';
import { PencilButtonThemeEnum } from 'src/app/standalones/components/pencil-button/pencil-button.component';
import { IconTypes } from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { IActiveFolder } from '../../content/files/files.component';

@Component({
  selector: 'app-create-folder-dialog',
  templateUrl: './create-folder-dialog.component.html',
  styleUrls: ['./create-folder-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateFolderDialogComponent {
  folderName = '';
  folderExists = false;
  readonly currentSubdirectories: string[];
  readonly PencilModalSizeEnum = PencilModalSizeEnum;
  readonly PencilButtonThemeEnum = PencilButtonThemeEnum;
  readonly IconTypes = IconTypes;

  constructor(
    public dialogRef: MatDialogRef<CreateFolderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { parent?: IActiveFolder; title: string },
  ) {
    this.currentSubdirectories = this.data.parent?.subdirectories.map((item) => item.name) ?? [];
  }

  get isCreateDisabled(): boolean {
    return this.folderName.trim().length === 0 || this.folderExists;
  }

  private normalizeFolderName(folderName: string): string {
    return folderName.trim().toLocaleLowerCase();
  }

  checkFolderName(): void {
    const normalizedFolderName = this.normalizeFolderName(this.folderName);
    this.folderExists = this.currentSubdirectories.some(
      (folderName) => this.normalizeFolderName(folderName) === normalizedFolderName,
    );
  }

  createFolder(): void {
    if (!this.isCreateDisabled) {
      this.dialogRef.close(this.folderName.trim());
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
